export default {
    apiv1: process.env.VUE_APP_API_BASE || "http://localhost:8000/api",
    api_full_url: window.location.origin,
    login: '/login',
    create_team: '/team/add_team',
    get_teams: '/team/get_teams',
    update_team: '/team/update_team',
    delete_team: '/team/delete_team',
    create_user: '/user/create_user',
    get_users: '/user/list_user',
    update_user: '/user/update_user',
    update_user_details: '/user/update_user_details',
    import_users: '/user/import_users',
    users_template: '/user/users_template',
    update_task_email_prefs: '/user/update_task_email_prefs',
    apply_task_email_team: '/user/apply_task_email_team',
    create_ticket: '/ticket/create_ticket',
    get_active_users: '/user/list_active_users',
    get_tickets: '/ticket/get_tickets',
    update_ticket_status: '/ticket/update_ticket_status',
    update_ticket: '/ticket/update_ticket',
    delete_ticket: '/ticket/delete_ticket',
    ticket_transfer: '/ticket/transfer_ticket',
    list_history: '/ticket/list_history',
    // Projects
    list_projects: '/project/list_projects',
    create_project: '/project/create_project',
    delete_project: '/project/delete_project',
    update_member: '/project/update_member',
    update_project_timeline: '/project/update_timeline',
    // Sprints
    create_sprint: '/sprint/create',
    list_sprints: '/sprint/list',
    update_sprint: '/sprint/update',
    start_sprint: '/sprint/start',
    complete_sprint: '/sprint/complete',
    reopen_sprint: '/sprint/reopen',
    sprint_board: '/sprint/board',
    sprint_board_project: '/sprint/board_project',
    sprint_gantt: '/sprint/gantt',
    sprint_progress: '/sprint/progress',
    sprint_workload: '/sprint/workload',
    sprint_velocity: '/sprint/velocity',
    sprint_backlog: '/sprint/backlog',
    assign_ticket: '/sprint/assign_ticket',
    list_all_sprints: '/sprint/list_all',
    // Notifications
    list_notifications: '/notification/list',
    mark_all_notifications_read: '/notification/mark_all_read',
    mark_notification_read: '/notification/mark_read',
    // IT support tickets
    it_list: '/it/list',
    it_create: '/it/create',
    it_update: '/it/update',
    it_update_status: '/it/update_status',
    it_delete: '/it/delete',
    it_add_comment: '/it/add_comment',
    it_activity: '/it/activity',
    it_transfer: '/it/transfer',
    // QA test cases
    qa_list: '/qa/list',
    qa_create: '/qa/create',
    qa_update: '/qa/update',
    qa_delete: '/qa/delete',
    qa_add_execution: '/qa/add_execution',
    qa_list_executions: '/qa/list_executions',
    qa_add_comment: '/qa/add_comment',
    qa_activity: '/qa/activity',
    qa_transfer: '/qa/transfer',
    // Dashboard
    dashboard_summary: '/dashboard/summary',
    dashboard_on_time_trend: '/dashboard/on-time-trend',
    global_search: '/search',
    // Stand-ups
    standup_submit: '/standup/submit',
    standup_list: '/standup/list',
    standup_overview: '/standup/overview',
    standup_history: '/standup/history',
    standup_delete: '/standup/delete',
    standup_prefill: '/standup/prefill',
    // AI assistant
    ai_status: '/ai/status',
    ai_suggest_ticket: '/ai/suggest_ticket'
}